import { useTranslation } from "react-i18next";

interface Props {
  english: string;
  french: string;
}

const useTranslationCondition = ({ english, french }: Props) => {
  const { i18n } = useTranslation();
  return i18n.language.startsWith("en") ? english : french;
};

export default useTranslationCondition;
